import { Box, Button } from "@mui/material";
import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";
import { useEffect, useState } from "react";
import { io } from "socket.io-client";
import { primaryButtonStyles } from "../../../../Styles/Styles";

const socket = io(process.env.REACT_APP_BACKEND_URL, {
  transports: ["websocket"],
});

const MESSAGES_PER_LOAD = 5;

const AdminLiveChatMonitor = () => {
  const [messages, setMessages] = useState([]);
  const [newMessageIds, setNewMessageIds] = useState([]);
  const [currentAnimatingMsg, setCurrentAnimatingMsg] = useState(null);
  const [skipCount, setSkipCount] = useState(0);
  const [loadingMore, setLoadingMore] = useState(false);
  const [hasMoreMessages, setHasMoreMessages] = useState(true); // <-- NEW

  const storedUser = localStorage.getItem("user");
  const user = storedUser ? JSON.parse(storedUser) : null;
  const adminUserId = user?._id;

  useEffect(() => {
    if (!adminUserId) return;

    socket.emit("join-admin", adminUserId);

    loadMessages(0); // Load initial messages

    socket.on("admin-monitor-message", (message) => {
      const tempId = Date.now();
      message._tempId = tempId;

      setMessages((prev) => [message, ...prev]);
      setNewMessageIds((ids) => [...ids, tempId]);
      setCurrentAnimatingMsg(message);

      setTimeout(() => setCurrentAnimatingMsg(null), 4000);
      setTimeout(() => {
        setNewMessageIds((ids) => ids.filter((id) => id !== tempId));
      }, 10000);
    });

    return () => {
      socket.off("admin-monitor-message");
      socket.off("admin-previous-messages");
    };
  }, [adminUserId]);

  const loadMessages = (skip) => {
    setLoadingMore(true);

    socket.emit("get-admin-previous-messages", {
      skip,
      limit: MESSAGES_PER_LOAD,
    });

    socket.once("admin-previous-messages", (newMessages) => {
      if (skip === 0) {
        setMessages(newMessages);
      } else {
        setMessages((prev) => [...prev, ...newMessages]);
      }

      // If fewer messages returned than requested, no more to fetch
      if (newMessages.length < MESSAGES_PER_LOAD) {
        setHasMoreMessages(false);
      }

      setLoadingMore(false);
    });
  };

  const handleViewMore = () => {
    const newSkip = skipCount + MESSAGES_PER_LOAD;
    setSkipCount(newSkip);
    loadMessages(newSkip);
  };

  return (
    <Box sx={{ padding: 3 }}>
      <h2 style={{ marginBottom: "24px" }}>Live Chat Monitor</h2>

      <Box sx={{ maxWidth: 600 }}>
        <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
          {messages.map((msg, i) => {
            const isNew = newMessageIds.includes(msg._tempId);
            return (
              <li
                key={msg._tempId || i}
                style={{
                  backgroundColor: isNew
                    ? "rgba(255, 150, 150, 0.2)"
                    : "#f9f9f9",
                  borderRadius: 8,
                  padding: "12px 16px",
                  marginBottom: 12,
                  transition:
                    "background-color 0.5s ease, box-shadow 0.5s ease",
                  boxShadow: isNew
                    ? "0 0 10px rgba(255,0,0,0.2)"
                    : "0 1px 3px rgba(0,0,0,0.05)",
                  fontWeight: isNew ? "600" : "normal",
                }}
              >
                <div>
                  <strong>From:</strong>{" "}
                  {msg.sender?.firstName + " " + msg.sender?.lastName ||
                    msg.sender?.username ||
                    "Unknown"}
                </div>
                <div>
                  <strong>Ad:</strong> {msg.adTitle || "No Ad"}
                </div>
                <div>
                  <strong>Message:</strong> {msg.content}
                </div>
                <div>
                  <strong>At:</strong>{" "}
                  {new Date(msg.timestamp).toLocaleString()}
                </div>
              </li>
            );
          })}
        </ul>

        {hasMoreMessages && (
          <Button
            className="main-button-style"
            onClick={handleViewMore}
            disabled={loadingMore}
            sx={{ mt: 2, ...primaryButtonStyles }}
          >
            {loadingMore ? (
              <>
                <span>Loading...</span>
                <ArrowForwardOutlinedIcon />
              </>
            ) : (
              <>
                <span>View More</span>
                <ArrowForwardOutlinedIcon />
              </>
            )}
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default AdminLiveChatMonitor;
